// from general.js
/* global hideScreenAndOverlay */


/**
 *  After photo crop or upload, the classroom photo on the underlying page is updated
 *  when the img or tag with background image is marked with a classname:
 *  js-classroom-photo-format-[thumbnail, small, medsmall, med, retina]-[optional bg]
 *
 * This generates a global updateClassroomPhotoOnUnderlyingPage function to be called
 * via window.postMessage when photo crop finishes -- see teacherClassroomPhotoCrop.js.
 *
 * @param customClassroomPhotoUpdateFunction Optional custom handler for upload success
 */
export function registerUpdateClassroomPhotoOnUnderlyingPage(customClassroomPhotoUpdateFunction) {
    window.updateClassroomPhotoOnUnderlyingPage = (data) => {
        $('[class*=\'js-classroom-photo-format\']').each(function () {
            const updateClassName = $.grep(this.className.split(' '), function (v, i) {
                return v.indexOf('js-classroom-photo-format') === 0;
            }).join();
            const updateClassNameArr = updateClassName.split('-');
            const size = updateClassNameArr[4];

            const isBackground = (updateClassNameArr[5] === 'bg');
            const updatedImageURL = (data && data.photoURLs) ? data.photoURLs[size] : null;

            // If this page has its own global on-classroom-photo-upload-success function, just call that!
            if (customClassroomPhotoUpdateFunction) {
                customClassroomPhotoUpdateFunction();
            } else if (updatedImageURL) {
                if ($('.drafted-photo-help').length > 0) {
                    $('.drafted-photo-help').hide();
                }
                if (isBackground) {
                    $(this).css('background-image', 'url(' + updatedImageURL + ')');
                } else {
                    $(this).attr('src', updatedImageURL);
                }
            }
        });
        if (data && data.hideScreenAndOverlay) {
            hideScreenAndOverlay();
            $('body').trigger('photoUploadComplete.classroomPhoto');
        }
    };
}
